export const getSessionStorageItem = (
  itemName: string,
): string | null | undefined => {
  if (typeof window === 'undefined' || !itemName) return undefined;

  try {
    return sessionStorage.getItem(itemName);
  } catch (_error) {
    return undefined;
  }
};

export const getLocalStorageItem = (
  itemName?: string | null,
): string | null | undefined => {
  if (typeof window === 'undefined' || !itemName) return undefined;

  try {
    return localStorage.getItem(itemName);
  } catch (_error) {
    return undefined;
  }
};

export const setLocalStorageItem = (itemName: string, itemValue: string) => {
  if (typeof window === 'undefined' || !itemName) return undefined;

  try {
    return localStorage.setItem(itemName, itemValue);
  } catch (_error) {
    return undefined;
  }
};

export const setSessionStorageItem = (itemName: string, itemValue: string) => {
  if (typeof window === 'undefined' || !itemName) return undefined;

  try {
    return sessionStorage.setItem(itemName, itemValue);
  } catch (_error) {
    return undefined;
  }
};

export const removeLocalStorageItem = (itemName: string) => {
  if (typeof window === 'undefined' || !itemName) return undefined;

  try {
    return localStorage.removeItem(itemName);
  } catch (_error) {
    return undefined;
  }
};
